export default __webpack_public_path__ + "static/media/argentina.06589436.png";